module.exports = __webpack_public_path__ + "img/5-stylists-tape.png";